import { render, staticRenderFns } from "./FormCatequista.vue?vue&type=template&id=7382e001&"
import script from "./FormCatequista.vue?vue&type=script&lang=js&"
export * from "./FormCatequista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports